import Vue from 'vue'
import Const from "@/helpers/Const";
import store from '@/store'
import VueRouter from 'vue-router'

import NotAppView from '../views/NotAppView.vue'
import LayoverView from '../views/LayoverView.vue'
import SubscGuideView from '../views/Subsc/SubscGuideView'
import SubscView from '../views/Subsc/SubscStatus/SubscView.vue'
import SubscListItemView from '../views/Subsc/SubscStatus/SubscListItemView.vue'
import SubscRevokeView from '../views/Subsc/SubscRevokeView.vue'
import SubscApplyTermView from '../views/Subsc/SubscApply/SubscApplyTermView.vue'
import SubscApplyTermInsuranceView from '../views/Subsc/SubscApply/SubscApplyTermInsuranceView.vue'
import SubscApplyVehicleRegView from '../views/Subsc/SubscApply/SubscApplyVehicleRegView.vue'
import SubscApplyVehicleView from '../views/Subsc/SubscApply/SubscApplyVehicleView.vue'
import SubscApplyPkgView from '../views/Subsc/SubscApply/SubscApplyPkgView.vue'
import SubscApplyVehicleInspView from '../views/Subsc/SubscApply/SubscApplyVehicleInspView.vue'
import SubscApplyVehiclePanelView from '../views/Subsc/SubscApply/SubscApplyVehiclePanelView.vue'
import SubscApplyReqView from '../views/Subsc/SubscApply/SubscApplyReqView.vue'
import SubscApplyResView from '../views/Subsc/SubscApply/SubscApplyResView.vue'

import TermInfo from '../views/Term/TermInfo.vue'

import GuideSubscApplyView from '../views/guide/GuideSubscApplyView.vue'
import GuideInsuranceView from '../views/guide/GuideInsuranceView.vue'
import GuideTotalView from '../views/guide/GuideTotalView.vue'
import GuideWarrantyView from '../views/guide/GuideWarrantyView.vue'

import TransferView from '../views/Transfer/TransferView.vue';
import SubscSolicitationView from "../views/Subsc/SubscSolicitation/SubscSolicitationView";

import SubscStatusVtgView from '../views/Subsc/SubscStatusVtg/SubscView.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'SubscGuide', //서비스 안내
    meta: {
      titleType:'',
    },
    component: SubscGuideView
  },
  {
    path: '/notApp',
    name: 'NotApp', //web chk
    meta: {
      titleType:'',
    },
    component: NotAppView
  },
  {
    path: '/layover',
    name: 'Layover', //결제결과 경유
    meta: {
      titleType:'',
    },
    component: LayoverView
  },

  {
    path: '/subscApply/term',
    name: 'SubscApplyTerm', //구독 약관 동의
    meta: {
      titleType:Const.HEADER_TITLE.APPLY,
    },
    component: SubscApplyTermView
  },
  {
    path: '/subscApply/vehicleReg',
    name: 'SubscApplyVehicleReg', //구독 차량 등록증 촬영
    meta: {
      titleType:Const.HEADER_TITLE.APPLY,
    },
    component: SubscApplyVehicleRegView
  },
  {
    path: '/subscApply/vehicle',
    name: 'SubscApplyVehicle', //구독 차량 정보 입력
    meta: {
      titleType:Const.HEADER_TITLE.APPLY,
    },
    component: SubscApplyVehicleView
  },
  {
    path: '/subscApply/pkg',
    name: 'SubscApplyPkg', //구독 신청 패키지 선택
    meta: {
      titleType:Const.HEADER_TITLE.APPLY,
    },
    component: SubscApplyPkgView
  },
  {
    path: '/subscApply/termInsurance',
    name: 'SubscApplyTermInsurance', //구독 보험 약관 동의
    meta: {
      titleType:Const.HEADER_TITLE.APPLY,
    },
    component: SubscApplyTermInsuranceView
  },
  {
    path: '/subscApply/vehicleInsp',
    name: 'SubscApplyVehicleInsp', //구독 신청 검사표 촬영
    meta: {
      titleType:Const.HEADER_TITLE.APPLY,
    },
    component: SubscApplyVehicleInspView
  },
  {
    path: '/subscApply/vehiclePanel',
    name: 'SubscApplyVehiclePanel', //구독 신청 계기판 촬영
    meta: {
      titleType:Const.HEADER_TITLE.APPLY,
    },
    component: SubscApplyVehiclePanelView
  },
  {
    path: '/subscApply/req',
    name: 'SubscApplyReq', //구독 신청 전송
    meta: {
      titleType:Const.HEADER_TITLE.APPLY,
    },
    component: SubscApplyReqView
  },
  {
    path: '/subscApply/res',
    name: 'SubscApplyRes', //구독 신청 결과
    meta: {
      titleType:'',
    },
    component: SubscApplyResView
  },

  {
    path: '/subscRevoke',
    name: 'SubscRevoke', //구독 해지 신청
    meta: {
      titleType:Const.HEADER_TITLE.MY,
    },
    component: SubscRevokeView
  },
  {
    path: '/subscStatus',
    name: 'Subsc', //구독 현황
    meta: {
      titleType:Const.HEADER_TITLE.MY,
    },
    component: SubscView
  },
  {
    path: '/subscStatus/subscs/:subsc_id',
    name: 'SubscListItem', //구독 현황 내 구독 목록 내 구독 항목
    meta: {
      titleType:Const.HEADER_TITLE.MY,
    },
    component: SubscListItemView
  },

  {
    path: '/termInfo/:type',
    name: 'TermInfo', //약관 이용
    meta: {
      titleType:Const.HEADER_TITLE.TERM,
    },
    component: TermInfo
  },

  {
    path: '/guide/subscApply',
    name: 'GuideSubscApply', // 구독 신청 방법
    meta: {
      titleType: 'BMW ServiceCare+ 구독 신청 방법',
    },
    component: GuideSubscApplyView
  },

  {
    path: '/guide/insurance',
    name: 'GuideInsurance', // 이용방법 - 보험 청구 방법
    meta: {
      titleType: 'BMW ServiceCare+ 이용 방법',
    },
    component: GuideInsuranceView
  },

  {
    path: '/guide/insurance/:careInsuranceConfirmId',
    name: 'GuideInsuranceSubmit', // 보험 청구 방법 및 청구
    meta: {
      titleType: 'ServiceCare+ 이용 방법',
    },
    component: GuideInsuranceView
  },

  {
    path: '/guide/total',
    name: 'GuideTotal',
    meta: {
      titleType: '구독 신청 방법 및 이용방법',
    },
    component: GuideTotalView
  },

  {
    path: '/guide/warranty',
    name: 'GuideWarranty',
    meta: {
      titleType: 'POWER TRAIN 상세보기',
    },
    component: GuideWarrantyView
  },

  {
    path: '/transfer/:subsc_id',
    name: 'Transfer',
    meta: {
      titleType: '양수 신청',
    },
    component: TransferView
  },

  {
    path: '/subscSolicitation/:hash/',
    name: 'SubscSolicitation', //구독 약관 동의
    meta: {},
    component: SubscSolicitationView
  },

  {
    path: '/subscStatusVtg',
    name: 'SubscVtg', //구독 현황
    meta: {
      titleType:Const.HEADER_TITLE.SHOT,
    },
    component: SubscStatusVtgView
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

// 적용시 to.name --> to.path
// const passAble = ['/layover'];
// const appAble = ['/', '/subscStatus','/subscRevoke'];
// const webAble = ['/', '/notApp', '/app', '/termInfo'];

// const passAble = ['Layover'];
// const appAble = ['SubscGuide', 'Subsc','SubscRevoke'];
// const webAble = ['SubscGuide', 'NotApp', 'TermInfo'];

const passAble = ['Layover'];
const appAble = ['SubscGuide', 'Subsc','SubscRevoke', 'GuideInsuranceSubmit', 'Transfer'];
const webAble = [
  'SubscGuide', 'NotApp', 'TermInfo', 'GuideSubscApply', 'GuideInsurance',
  'SubscSolicitation'
];

appAble.push('SubscApplyReq');
appAble.push('subscStatus');
appAble.push('SubscApplyVehicle');


router.beforeEach((to, from, next) => {
  window.scrollTo(0,0)
  document.body.scrollTop = 0;

  // pass
  if(passAble.includes(to.name)){
    return next();
  }
  //가입 결제완료, my Bmw Prime 으로 이동시 plus_id가 있고 빈값이 아닐경우 next()
  else if( appAble.includes(to.name) && typeof to.query.vtg_id != 'undefined' && to.query.vtg_id != ''){
    return next();
  } 

  //페이지 사용불가 체크
  else if( 
    !webAble.includes(to.name) && 
    !store.state.isApp &&  // app X
    !store.state.isDev     // dev X
  ){
    if(from.name == '/notApp') return false; // or notApp
    return router.push('/notApp');
  } 
  else {
    // if(store.state.user.plus_id) to.query.plus_id = store.state.user.plus_id;
    return next();
  }
});

window.onpopstate = function(){
  let popups = Object.getOwnPropertyNames(store.state.openedPopup).reverse();
  for (let i in popups){
    let popup = popups[i]
    if (store.state.openedPopup[popup] !== undefined && store.state.openedPopup[popup].opened){
      history.pushState(null, '', document.location.href);
      break;
    }
  }
}

export default router;